export default "* 1-2 bløde skumbolde\n* Evt. vest eller bånd til at synliggøre, hvem der er jæger\n* Evt. kegler, reb eller lign. til markering af bane";